// React
import React from 'react';
// External libraries
import {
    Col, Container, Image, Row
} from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
// Internal
import LoginForm from 'components/auth/FormLogin';
import config from 'config/config';
import BrandService from 'services/brand';
// Styles
import './styles.scss';
// Images
import paw from 'assets/images/paw.png';

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.location = props.location;
        this.hideNav = props.hideNav === true ? 'hide' : ' ';
        this.state = {
            imgSrc: '',
            headingMessage: ''
        };
        this.getBrandImage();
    }

    /**
     * Gets the brand logo to display in the app
     */
    getBrandImage()  {
        let url = window.location.hostname
        let brand = ''
        let business = '';

        if (url === 'portal.lawnswood.com.au') {
            brand = 'WA LWD';
            business = 'Lawnswood'
        }

        if (url === 'portal.edenhills.com.au') {
            brand = 'VIC EDH';
            business = 'Edenhills'
        }       

        BrandService.getBrand(brand)
            .then((response) => {
                if (business === 'Lawnswood') {
                    this.setState({ headingMessage: 'Enter your account username and password below to log into the Lawnswood Vet Portal' });
                } else if (business === 'Edenhills') {
                    this.setState({ headingMessage: 'Enter your account username and password below to log into the Edenhills Vet Portal.' });
                } else {
                    this.setState({ headingMessage: 'Enter your account username and password below to log into the Vet Portal.' });
                    return;
                }

                this.setState({ imgSrc: response.data.brand_logo_link });
            }).catch((err) => {
                console.error(err);
            });
    }

    render() {
        return (
            <Container fluid className="login-page-wrapper">
                <Row className="login-page">
                    <Col className="left-section" md="auto" />
                    <Col className="right-section">
                        <div className="login-form-wrapper">
                            <div className="logo-wrapper">
                                <Image
                                    alt={config.webTitle}
                                    src={this.state.imgSrc}
                                    className="login-logo"
                                    height="40"
                                />
                            </div>

                            <div className="heading-wrapper">
                                <h1 className="page-heading">Welcome to our Vet Portal</h1>
                                <p className="inline-block-below-lg">
                                    {this.state.headingMessage}
                                </p>
                            </div>

                            <div className="form-wrapper">
                                {
                                    typeof (this.props.match.params.bookingId) === 'undefined'
                                    && typeof (this.props.match.params.quotedProductId) === 'undefined'
                                        ? (<LoginForm />) : (
                                            <LoginForm
                                                bookingId={this.props.match.params.bookingId}
                                                quotedProductId={this.props.match.params.quotedProductId}
                                            />
                                        )
                                }
                            </div>
                            <Image alt="Pet paw" src={paw} className="image-paw" />
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withRouter(Login);
